import React from 'react'

export const useCardInfoForm = () => {
  const [isReady, setIsReady] = React.useState(false)

  /*
   * Callback
   * > save validation state of card form
   */
  const handleCardInfoCompleteChange = React.useCallback(
    ({ complete }) => {
      setIsReady(complete)
    },
    [setIsReady],
  )

  return [isReady, handleCardInfoCompleteChange]
}
